import { SaveTypeCompras } from '../../shared/saveTypeCompras';

export interface CreateTypeComprasPageInterface {}

const CreateTypeComprasPage: React.FC<CreateTypeComprasPageInterface> = () => {
  return <SaveTypeCompras titlePage="Crear Tipo compras" />;
};

export default CreateTypeComprasPage;
